import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

import { XMarkIcon } from '~/assets/icons'
import { heightFooterSticky, marginX } from '~/constants'
import { dataCartSelector, clearAllCart, dataRestaurantFromCartSelector } from '~/redux/cartSlice'

import CartEmpty from './components/CartEmpty'
import CartItem from './components/CartItem'
import FooterCart from './components/FooterCart'
import { ThemeContext } from '~/theme/ThemeProvider'
import { selectRestaurant } from '~/redux/restaurantSlice'
import { isHidePlusFoodEnable } from '~/utils'

const YourCart = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const itemsCart = useSelector(dataCartSelector)
  const { food_court_id, extraFeatures } = useSelector(selectRestaurant)
  const restaurant_cart = useSelector(dataRestaurantFromCartSelector)
  const { currentThemeObject } = useContext(ThemeContext)

  const renderFooterCartSticky = () => {
    return <FooterCart />
  }

  // Hiển thị danh sách món ăn trong trường hợp không phải food court
  const renderListFood = () => {
    return itemsCart.map((item) => {
      return (
        <CartItem
          key={item.primaryKey}
          {...item}
          isHidePlusFoodItemEnable={isHidePlusFoodEnable(extraFeatures)}
        />
      )
    })
  }

  // Hiển thị tên nhà hàng
  const renderNameRestaurant = (nameRestaurant) => {
    return (
      <Box display="flex" alignItems="center" marginTop="32px">
        <Box color="baseColor.colorText1" fontSize="2rem" fontWeight="600" letterSpacing="-0.3px">
          {nameRestaurant}
        </Box>

        <Box flex={1} height="2px" bgcolor="baseColor.colorText1" ml="8px" />
      </Box>
    )
  }

  // Hiển thị nhóm món ăn đi theo nhà hàng trong trường hợp food court
  const renderGroupFood = () => {
    const dataCartGroup = _.groupBy(itemsCart, (item) => item.restaurant_id) // group món ăn theo nhà hàng
    const restaurantIds = Object.keys(dataCartGroup)

    return restaurantIds.map((restaurant_id) => {
      const foodList = dataCartGroup[restaurant_id]
      const infoRestaurant = restaurant_cart[restaurant_id]

      return (
        <Box key={restaurant_id}>
          {renderNameRestaurant(infoRestaurant?.name)}
          {foodList.map((item) => (
            <CartItem key={item.primaryKey} {...item} />
          ))}
        </Box>
      )
    })
  }

  /**
   * Hiển thị list food theo 2 trường hợp:
   * 1. Trường hợp nhà hàng không thuộc food court -> Hiển thị danh sách món ăn như bình thường không bao gồm tên nhà hàng
   * 2. Trường hợp nhà hàng thuộc food court -> Hiển thị danh sách món ăn group theo nhà hàng (Bao gồm tên nhà hàng)
   */
  const renderContent = () => {
    if (itemsCart.length) {
      return <Box>{food_court_id ? renderGroupFood() : renderListFood()}</Box>
    }
    return <CartEmpty />
  }

  // Trong trường hợp là Food court -> không hiển thị title "Your cart"
  const renderTitleCart = () => {
    if (food_court_id) return null

    return (
      <Box display="flex" alignItems="center" mt="20px">
        <Box flex={1} height="3px" backgroundColor={'baseColor.colorText1'} marginRight="8px" />
        <Typography fontSize="2.8rem" fontWeight="600" color={'baseColor.colorText1'}>
          {t('titles.in_your_cart')}
        </Typography>
      </Box>
    )
  }

  const clearAllCartHandler = () => {
    dispatch(clearAllCart())
  }

  const renderBtnClearAll = () => {
    return (
      <Typography
        onClick={clearAllCartHandler}
        color="baseColor.color10"
        textAlign="right"
        fontSize="1.6rem"
        fontWeight="600"
        sx={{
          textDecoration: 'underline',
        }}>
        {t('actions.clear_all')}
      </Typography>
    )
  }

  const goBackHandler = () => {
    navigate(-1)
  }

  const renderBackBtn = () => {
    return (
      <Box display="flex" onClick={goBackHandler}>
        <XMarkIcon color={currentThemeObject.colorText1} />
      </Box>
    )
  }

  return (
    <Box
      bgcolor="baseColor.color1"
      component="div"
      marginX={`${marginX}px`}
      paddingTop="16px"
      paddingBottom={`${heightFooterSticky + 20}px`}
      height="100%"
      minHeight="100vh">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {renderBackBtn()}
        {renderBtnClearAll()}
      </Box>
      {renderTitleCart()}
      {renderContent()}
      {renderFooterCartSticky()}
    </Box>
  )
}

export default React.memo(YourCart)
